import './App.css';
import Adabiyot from './Components/Adabiyot';
import Glossariy from './Components/Glossariy';
import Header from './Components/Header';
import Ilovalar from './Components/Ilovalar';
import Laborotoriya from './Components/Laborotoriya';
import Muallif from './Components/Muallif';
import NameLesson from './Components/NameLesson';
import Test from './Components/Test';
import Titul from './Components/Titul';
import Video from './Components/Video';

function App() {
  return (
    <div className="App">
      <div className='header'> 
        <Header />
        <NameLesson />
      </div>
      <div className='main'>
        <Titul />
        <Laborotoriya />
        <Ilovalar />
        <Glossariy />
        <Adabiyot /> <br />
        <Video />
        <Test />
        <Muallif />
      </div>
    </div>
  );
}

export default App;
